import {isLoggingOut} from '@albert-io/mandark/authentication/logoutState';

import {isTransportError} from 'lib/normalizeError';
import {redirectToSessionExpiredFromLocation} from 'lib/postLoginRedirect';
import {isUnauthenticated, sessionStillValid} from 'lib/sessionStillValid';

import {getDraftGuess} from './QuestionType.queries';

/** Stands in for a 401 draft load once the session is over, so callers skip the report. */
export class SessionEndedDuringDraftLoadError extends Error {
  constructor() {
    super('The session ended while the draft guess was loading.');
    this.name = 'SessionEndedDuringDraftLoadError';
  }
}

export const shouldReportDraftLoadFailure = (error: unknown): boolean =>
  !isTransportError(error) && !(error instanceof SessionEndedDuringDraftLoadError);

/**
 * Loads a question's draft rows. A 401 is answered by re-checking the session: still valid
 * retries once, gone sends the student to sign in and throws `SessionEndedDuringDraftLoadError`.
 */
export async function getDraftGuessWithSessionRecovery(
  questionId: string | null,
  assignmentId: string | null
) {
  try {
    return await getDraftGuess(questionId, assignmentId, {suppressGlobalErrorToast: true});
  } catch (error) {
    if (!isUnauthenticated(error)) throw error;
    if (await sessionStillValid()) return getDraftGuess(questionId, assignmentId);
    if (!isLoggingOut()) redirectToSessionExpiredFromLocation();
    throw new SessionEndedDuringDraftLoadError();
  }
}
